// @flow
/* eslint no-useless-computed-key:0 */

import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Spinner as GestaltSpinner } from 'gestalt';

export type Name = 'None' | 'No' | 'Yes';

export const Spinner = () => (
  <div
    style={{
      alignItems: 'center',
      background: '#fff',
      borderRadius: '8px',
      display: 'flex',
      height: '155px',
      justifyContent: 'center',
      outline: 'none',
      width: '300px',
    }}
  >
    <GestaltSpinner accessibilityLabel={i18n._('Tried it')} show />
  </div>
);

export type ResourceOptions = {
  details: string,
  pin_id: string,
  recommend_score?: number,
  image_signatures?: string,
};

export default null;
